import React,{useEffect,useRef} from 'react';
import { Select } from 'antd';
import 'antd/dist/antd.css';
import {getFuelMarketData} from '../services/chartdata'
import {barOption,percentOption,fillSeries} from '../utils/chartOptionConfig'

//按需加载
import echarts from 'echarts/lib/echarts'
//必需基础组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markPoint'
//导入矩形图
import 'echarts/lib/chart/bar'　
import 'echarts/lib/chart/line'　





export default function FuelMakret(props) {
	const { Option } = Select;

	function handleChange(value) {
		console.log(`selected ${value}`);		
		renderMyChart(value);
	}

	const totalChartRef=useRef();
	const chartRef=useRef();

	let totalChart;
	let fuelChart;

	let myChart=null;
	
	function getChart(ref){
		let chart=echarts.getInstanceByDom(ref)
		let myChart=null;
		if(chart){
			myChart=chart;
		}else{
			myChart=echarts.init(ref);
		}
		return myChart;
	}

	function renderMyChart(fuelType){
		fuelType=fuelType||2;
		// fuelType=2;
		getFuelMarketData().then((dt)=>{			
			
			// jsonData=dt;
			let totalMarketDatalist=dt[0].dataList;
			let res=totalMarketDatalist.map(obj=>{
				let new_obj={};				
				for(let [k,v] of Object.entries(obj)){					
					if(Array.isArray(v)){
						// new_obj[k]=v[numType];
						new_obj[k]=v[2].toFixed(1);
					}else{
						new_obj[k]=v;
					}
				}
				return new_obj;
			})
			// console.log('res',res);
			totalChart= getChart(totalChartRef.current);
			
			// totalChart.setOption(barOption);
			totalChart.setOption({			
				...barOption,				
				title:{'text':'整体市场'},
				dataset:{
					source:res
				}
			})
			// barOption
			
			
			let fuelMarketDatalist=dt[fuelType].dataList;
			res=fuelMarketDatalist.map(obj=>{
				let new_obj={};				
				for(let [k,v] of Object.entries(obj)){
					if(fuelType==1&&(['Hybrid','ICE'].includes(k))){
					
						continue;
					}
					if(Array.isArray(v)){
						// new_obj[k]=v[numType];
						new_obj[k]=v[2].toFixed(1);
					}else{
						new_obj[k]=v;
					}
				}
				return new_obj;
			})
			// console.log('res',res);
			fuelChart= getChart(chartRef.current);
			let series=fillSeries(2);
			// console.log('series',series)
			// fuelChart.setOption(percentOption);

			// let series=fuelChart.getOption().series;
			// console.log('series length',series.length)
			// if(series.length>2){
			// 	for(let i=2;i<series.length;i++){
			// 		series.pop();
			// 	}
			// }
			// console.log('after series length',series.length)
			// console.log(series)
			fuelChart.setOption({...percentOption,
				grid:{
					top:80,
					left:10,
					right:10
				},
				series:series,
				title:{'text':'销量占比'},
				dataset:{
					source:res
				}
			},true)

      
		});
	}
	// 

	useEffect(()=>{
		// console.log("did.....")
		renderMyChart();
		return ()=>{
			// console.log("unmount...");
			myChart && myChart.dispose();
		}
	})
	return (
		<>
		<div>	
			<div style={{width: "1100px", height: "400px"}} ref={totalChartRef} />
			<div className="select">
			<Select defaultValue="2" style={{ width: 150 }} onChange={handleChange}>				
				<Option value="1">BEV、PHEV</Option>				
				<Option value="2">ICE、NEV</Option>				
			</Select>
			</div>

			<div style={{width: "1100px", height: "400px"}} ref={chartRef} />
		</div>

		</>
	);
}
